import styled from 'styled-components'

import { BaseCell } from '../../DataGrid.styles'

export const HeaderGroupCellRoot = styled(BaseCell)<{
  $colStart: number
  $colEnd: number
}>`
  grid-column-start: ${({ $colStart }) => $colStart};
  grid-column-end: ${({ $colEnd }) => $colEnd};
  grid-row-start: 1;
  grid-row-end: 2;
  background-color: ${({ theme }) => theme.header.groupBackground};
  position: sticky;
  display: flex;
  align-content: center;
  top: 0;
  z-index: ${({ $isSticky }) => ($isSticky ? 3 : 2)};
  color: ${({ theme }) => theme.header.groupColor};
  font-weight: 500;
`

export const ColumnGroupLabel = styled.div`
  display: flex;
  position: sticky;
  left: 10px;
  right: 10px;
`
